module.exports = __webpack_public_path__ + "img/boating.f9c94310.png";